<script>
import NavBar from '@components/NavBar/NavBar.vue'

export default {
  components: { NavBar },
}
</script>

<template>
  <div :class="$style.container">
    <NavBar/>
    <slot/>

    <div
        class="md:hidden fixed inset-0 flex flex-col justify-center items-center bg-body-black text-onvocado-white text-sm text-center z-50">
      <span
          class="mx-4 mb-1">Your screen is too small. Please use a desktop device to access the Onvocado editor.</span>
      <router-link
          :to="{ name: 'dashboard' }"
          class="underline">
        Back To Dashboard
      </router-link>
    </div>
  </div>
</template>

<style lang="scss" module>
.container {
  width: 100%;
  margin: 0;

  // ------Scrollbar Styling START------
  ::-webkit-scrollbar {
    width: 0.5rem;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    @apply bg-onvocado-gray-dark border-2 border-solid border-body-black rounded-bl-full;
  }

  // ------Scrollbar Styling END------
}
</style>

<style lang="css" scoped>
  @import '~quill/dist/quill.snow.css';
</style>